function focusMe() {
  'ngInject';
  return {
    restrict: 'A',
    scope: {
      trigger: '=focusMe'
    },
    controller: 'FocusMeController'
  };
}

function FocusMeController($timeout, $element, $scope) {
  'ngInject';
  $scope.$watch('trigger', _handleTrigger);

  function _handleTrigger(value) {

    if (!value) { return; }

    $timeout(function() {
      $element[0].focus();
    });

  }
}

export { FocusMeController, focusMe };
